import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ component: Component }) => {
  // Check if the user is logged in by checking localStorage or sessionStorage
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  if (!isLoggedIn) {
      // If not logged in, redirect to login page
    localStorage.removeItem("isLoggedIn");
    return <Navigate to="/" />;
  }

  // If logged in, render the requested component
  return <Component />;
};

export default PrivateRoute;
